export enum EquationTypes {
  Unknown = 0,
  Sum = 1,
  SumBy = 2,
  Custom = 3,
  SumByAndDisplayBy = 4,
  PercentageOf = 5,
  DividedBy = 6,
  First = 7
}
